import * as actions from "./actions";

let initialState = {
  ucReports: {
    fetching: false,
    fetched: false,
    fetchError: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },

  taxReports: {
    SEK: {
      fetching: false,
      fetched: false,
      error: null,
      data: {
        Amount: null,
        AccountingAmountSek: null,
        From: null,
        To: null,
        AccountingAmountOriginalCurrency: null,
      },
    },
    EUR: {
      fetching: false,
      fetched: false,
      error: null,
      data: {
        Amount: null,
        AccountingAmountSek: null,
        From: null,
        To: null,
        AccountingAmountOriginalCurrency: null,
      },
    },
  },

  taxTransfer: {
    sending: false,
    sent: false,
    error: null,
  },

  monthlyReports: {
    fetching: false,
    fetched: false,
    error: null,
    data: {},
  },

  borrowerDepots: {
    fetching: false,
    fetched: false,
    error: null,
    data: [],
  },
};

const reports = (state = initialState, action) => {
  switch (action.type) {
    case actions.UC_REPORTS_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        ucReports: Object.assign({}, state.ucReports, {
          table: Object.assign({}, state.ucReports.table, {
            pagination: Object.assign({}, state.ucReports.table.pagination, {
              page: action.page,
            }),
          }),
        }),
      });
    case actions.UC_REPORTS_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        ucReports: Object.assign({}, state.ucReports, {
          table: Object.assign({}, state.ucReports.table, {
            currentFilter: Object.assign(
              {},
              state.ucReports.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    // Get tax report
    case actions.TAX_REPORTS_GET_REQUEST:
      return Object.assign({}, state, {
        taxReports: Object.assign({}, state.taxReports, {
          SEK: Object.assign({}, state.taxReports.SEK, {
            fetching: true,
          }),
        }),
      });
    case actions.TAX_REPORTS_GET_SUCCESS:
      return Object.assign({}, state, {
        taxReports: Object.assign({}, state.taxReports, {
          SEK: Object.assign({}, state.taxReports.SEK, {
            fetching: false,
            fetched: true,
            data: action.response,
          }),
        }),
      });
    case actions.TAX_REPORTS_GET_ERROR:
      return Object.assign({}, state, {
        taxReports: Object.assign({}, state.taxReports, {
          SEK: Object.assign({}, state.taxReports.SEK, {
            fetching: false,
            error: action.error,
          }),
        }),
      });
    case actions.EURO_TAX_REPORTS_GET_REQUEST:
      return Object.assign({}, state, {
        taxReports: Object.assign({}, state.taxReports, {
          EUR: Object.assign({}, state.taxReports.EUR, {
            fetching: true,
          }),
        }),
      });
    case actions.EURO_TAX_REPORTS_GET_SUCCESS:
      return Object.assign({}, state, {
        taxReports: Object.assign({}, state.taxReports, {
          EUR: Object.assign({}, state.taxReports.EUR, {
            fetching: false,
            fetched: true,
            data: action.response,
          }),
        }),
      });
    case actions.EURO_TAX_REPORTS_GET_ERROR:
      return Object.assign({}, state, {
        taxReports: Object.assign({}, state.taxReports, {
          EUR: Object.assign({}, state.taxReports.EUR, {
            fetching: false,
            error: action.error,
          }),
        }),
      });
    case actions.TAX_TRANSFER_REQUEST:
      return Object.assign({}, state, {
        taxTransfer: Object.assign({}, state.taxTransfer, {
          sending: true,
        }),
      });
    case actions.TAX_TRANSFER_SUCCESS:
      return Object.assign({}, state, {
        taxTransfer: Object.assign({}, state.taxTransfer, {
          sending: false,
          sent: true,
          error: null,
        }),
      });
    case actions.TAX_TRANSFER_ERROR:
      return Object.assign({}, state, {
        taxTransfer: Object.assign({}, state.taxTransfer, {
          sending: false,
          error: action.error,
        }),
      });
    // Monthly Reports
    case actions.MONTHLY_REPORTS_GET_REQUEST:
      return Object.assign({}, state, {
        monthlyReports: Object.assign({}, state.monthlyReports, {
          fetching: true,
        }),
      });
    case actions.MONTHLY_REPORTS_GET_SUCCESS:
      return Object.assign({}, state, {
        monthlyReports: Object.assign({}, state.monthlyReports, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    case actions.MONTHLY_REPORTS_GET_ERROR:
      return Object.assign({}, state, {
        monthlyReports: Object.assign({}, state.monthlyReports, {
          fetching: false,
          error: action.error,
        }),
      });
    // Depots fetch
    case actions.BORROWER_DEPOTS_FETCH_REQUEST:
      return Object.assign({}, state, {
        borrowerDepots: Object.assign({}, state.borrowerDepots, {
          fetching: true,
          fetched: false,
        }),
      });
    case actions.BORROWER_DEPOTS_FETCH_SUCCESS:
      return Object.assign({}, state, {
        borrowerDepots: Object.assign({}, state.borrowerDepots, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    case actions.BORROWER_DEPOTS_FETCH_ERROR:
      return Object.assign({}, state, {
        borrowerDepots: Object.assign({}, state.borrowerDepots, {
          fetching: false,
          fetched: true,
          error: action.error,
        }),
      });
    default:
      return state;
  }
};

export default reports;
